<div class="px-2">
  @if (view.isMobile) {
    <h3 class="text-center font-bold">{{'WELCOME_TO_YOUR_PLAYER_PROFILE' | translate}}</h3>
  } @else {
    <h2 class="text-center">{{'WELCOME_TO_YOUR_PLAYER_PROFILE' | translate}}</h2>
  }
  <div class="text-center pt-2 md:pb-2 md:text-lg">
    {{'PLAYER_PROFILE_INFO_TEXT' | translate}}
  </div>
  <div class="flex justify-content-center">
    <p-button styleClass="p-button-text" icon="pi pi-lightbulb"
              [label]="'DISCOVER_ALL_ADVANTAGES_OF_PLAYER_PROFILE' | translate"
              (click)="openPlayerProfileFeatures()"/>
  </div>

  @if (!settings?.registrationActive) {
    <div class="font-italic text-orange-frontend text-center py-2 text-lg md:text-xl">
      {{'COMING_SOON' | translate}}
    </div>
  }

  <div class="pt-3"></div>

  @if (!registrationSuccess && !showRegistration) {
    <div class="fadein animation-duration-200 pb-2" [class.fadeout]="fadeOutActive">
      <div class="flex justify-content-center pb-2">
        <div class="md:flex-1"></div>
        <p-panel class="flex-2 md:flex-2">
          <ng-template #header>
            <div class="flex items-center gap-2">
              <span class="material-symbols-outlined text-xl">frame_person</span>
              <span class="font-bold">{{'LOGIN' | translate}}</span>
            </div>
          </ng-template>

          <div class="text-center font-3k-header font-bold uppercase text-xl md:text-2xl accent-3k pb-3">
            {{ 'PLAYER_PROFILE_TITLE' | translate }}
          </div>
          <!--<div class="text-center pt-2 pb-3 text-lg md:text-xl">
            {{'LOGIN_HEADER' | translate}}
          </div>-->

          <app-player-profile-login-form (onShowRegistration)="showRegistration = true;"/>
        </p-panel>
        <div class="md:flex-1"></div>
      </div>
    </div>
  }

  <app-loading [active]="isLoading" [center]="true"/>
  <app-message [active]="!!errorMsg" [message]="errorMsg"/>

  @if (!isLoading && showRegistration) {
    @if (settings?.registrationActive || forceRegistration) {
      <div class="fadein animation-duration-200">
        <p-panel>
          <ng-template #header>
            <div class="flex items-center gap-2">
              <span class="material-symbols-outlined text-xl">frame_person</span>
              <span class="font-bold">{{'CREATE_ACCOUNT' | translate}}</span>
            </div>
          </ng-template>

          @if (!registrationSuccess) {
            <div class="text-center py-2 md:text-lg">
              {{'PLAYER_PROFILE_NO_REGISTERED_YET_FREE_REGISTRATION' | translate}}
            </div>
          }

          <app-player-profile-register-form (onSuccess)="fadeOutLogin()" [settings]="settings"/>

          <p-divider class="pt-3"/>
          <div class="flex justify-content-center pt-2">
            <div class="flex align-items-center gap-2">
              <span class="material-symbols-outlined text-xl">frame_person</span>
              <span class="font-italic">{{'ACCOUNT_ALREADY_EXISTS' | translate}}</span>
            </div>
          </div>
          <div class="flex justify-content-center pt-2">
            <p-button [label]="'LOGIN' | translate"
                      styleClass="p-button-text" size="large"
                      (onClick)="showRegistration = false"/>
          </div>
        </p-panel>
      </div>
    } @else {
      <div class="text-center py-2 md:text-lg">
        {{'PLAYER_PROFILE_REGISTRATION_INACTIVE' | translate}}
      </div>
    }
  }
</div>
